<template>
  <div class="overview-page">
    <h2>Dashboard Overview</h2>
    
    <div v-if="loading" class="loading">Loading statistics...</div>
    
    <div v-else class="stats-grid">
      <!-- Total Users -->
      <div class="stat-card users-card">
        <div class="stat-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>{{ stats.totalUsers }}</h3>
          <p>Total Users</p>
        </div>
      </div>

      <!-- Total Orders -->
      <div class="stat-card orders-card">
        <div class="stat-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>{{ stats.totalOrders }}</h3>
          <p>Total Orders</p>
        </div>
      </div>

      <!-- Revenue -->
      <div class="stat-card revenue-card">
        <div class="stat-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>${{ stats.totalRevenue.toFixed(2) }}</h3>
          <p>Total Revenue</p>
        </div>
      </div>

      <!-- In Progress Journeys -->
      <div class="stat-card journeys-card">
        <div class="stat-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
          </svg>
        </div>
        <div class="stat-content">
          <h3>{{ stats.inProgressJourneys }}</h3>
          <p>In Progress</p>
        </div>
      </div>
    </div>

    <!-- Recent Orders -->
    <div class="recent-section">
      <h3>Recent Orders</h3>
      <div v-if="recentOrders.length === 0" class="empty">No orders yet</div>
      <table v-else class="recent-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Total</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="order in recentOrders" 
            :key="order.id"
            @click="viewDetails(order)"
            class="clickable-row"
          >
            <td><code>{{ order.id.substring(0, 8) }}...</code></td>
            <td>{{ order.name || order.userEmail }}</td>
            <td>{{ order.total ? '$' + order.total : '-' }}</td>
            <td>
              <span :class="['status-badge', order.orderPaid ? 'paid' : 'unpaid']">
                {{ order.orderPaid ? 'Paid' : 'Unpaid' }}
              </span>
            </td>
            <td>{{ formatDate(order.timeOrdered) }}</td>
          </tr>
        </tbody>
      </table>
      <router-link to="/admin/orders" class="view-all-btn">View All Orders →</router-link>
    </div>

    <!-- Details Modal -->
    <div v-if="selectedItem" class="modal" @click.self="selectedItem = null">
      <div class="modal-body">
        <div class="modal-header">
          <h3>{{ selectedItem.name || selectedItem.productName || 'Order Details' }}</h3>
          <button class="close" @click="selectedItem = null">×</button>
        </div>

        <!-- Order Items -->
        <div v-if="selectedItem.order && selectedItem.order.length > 0" class="items-section">
          <h4>Order Items</h4>
          <div v-for="(item, idx) in selectedItem.order" :key="idx" class="order-item">
            <div class="item-info">
              <strong>{{ item.brand || item.product }}</strong>
              <p v-if="item.size">Size: {{ item.size }}</p>
              <p>Quantity: {{ item.quantity }}</p>
              <p>Price: ${{ item.price }}</p>
            </div>
            
            <!-- Item Personalization -->
            <div v-if="item.petName || item.profileType" class="personalization">
              <h5>Personalization</h5>
              <p v-if="item.profileType"><strong>Theme:</strong> {{ item.profileType }}</p>
              <p v-if="item.petName"><strong>Pet Name:</strong> {{ item.petName }}</p>
              <p v-if="item.petType"><strong>Pet Type:</strong> {{ item.petType }}</p>
              <p v-if="item.instagram"><strong>Instagram:</strong> @{{ item.instagram }}</p>
              <p v-if="item.comments"><strong>Comments:</strong> {{ item.comments }}</p>
            </div>

            <!-- Item Images -->
            <div v-if="item.imageUrls && item.imageUrls.length > 0" class="item-images">
              <h5>Uploaded Images ({{ item.imageUrls.length }})</h5>
              <div class="image-grid">
                <div 
                  v-for="(url, imgIdx) in item.imageUrls" 
                  :key="imgIdx"
                  class="image-item"
                  @click="openImage(url)"
                >
                  <img :src="url" :alt="`Image ${imgIdx + 1}`" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- All Uploaded Images (if available) -->
        <div v-if="selectedItem.uploadedImageUrls && selectedItem.uploadedImageUrls.length > 0" class="all-images-section">
          <h4>All Uploaded Images ({{ selectedItem.uploadedImageUrls.length }})</h4>
          <div class="image-grid">
            <div 
              v-for="(url, idx) in selectedItem.uploadedImageUrls" 
              :key="idx"
              class="image-item"
              @click="openImage(url)"
            >
              <img :src="url" :alt="`Image ${idx + 1}`" />
            </div>
          </div>
        </div>

        <!-- Customer Info -->
        <div class="customer-info">
          <h4>Customer Information</h4>
          <p><strong>Name:</strong> {{ selectedItem.name }}</p>
          <p><strong>Email:</strong> {{ selectedItem.emailAddress || selectedItem.accountEmail }}</p>
          <p v-if="selectedItem.address"><strong>Address:</strong> {{ formatAddress(selectedItem.address) }}</p>
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <div v-if="imageModalUrl" class="image-modal" @click="imageModalUrl = null">
      <div class="image-modal-content" @click.stop>
        <img :src="imageModalUrl" alt="Full size image" />
        <button class="close-image" @click="imageModalUrl = null">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/init';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';

export default {
  name: "OverviewPage",
  data() {
    return {
      loading: true,
      stats: {
        totalUsers: 0,
        totalOrders: 0,
        totalRevenue: 0,
        inProgressJourneys: 0
      },
      recentOrders: [],
      selectedItem: null,
      imageModalUrl: null
    };
  },
  methods: {
    async fetchStatistics() {
      this.loading = true;
      try {
        // Fetch users count
        const usersSnap = await getDocs(collection(db, 'users'));
        this.stats.totalUsers = usersSnap.size;

        // Fetch orders
        const ordersSnap = await getDocs(collection(db, 'orders'));
        this.stats.totalOrders = ordersSnap.size;
        console.log('Total orders found:', ordersSnap.size);
        
        // Calculate revenue
        let revenue = 0;
        ordersSnap.forEach(doc => {
          const data = doc.data();
          if (data.orderPaid && data.total) {
            revenue += parseFloat(data.total);
          }
        });
        this.stats.totalRevenue = revenue;

        // Fetch recent orders
        try {
          const recentQuery = query(
            collection(db, 'orders'),
            orderBy('timeOrderedTs', 'desc'),
            limit(5)
          );
          const recentSnap = await getDocs(recentQuery);
          this.recentOrders = recentSnap.docs.map(d => ({ id: d.id, ...d.data() }));
          console.log('Recent orders (with ordering):', this.recentOrders.length);
        } catch (orderError) {
          // If timeOrderedTs doesn't exist, try without ordering
          console.warn('Could not order by timeOrderedTs, fetching without ordering', orderError);
          const ordersRef = collection(db, 'orders');
          const ordersSnap = await getDocs(ordersRef);
          this.recentOrders = ordersSnap.docs
            .map(d => ({ id: d.id, ...d.data() }))
            .sort((a, b) => {
              const aTime = a.timeOrderedTs || a.timeOrdered || 0;
              const bTime = b.timeOrderedTs || b.timeOrdered || 0;
              return bTime - aTime;
            })
            .slice(0, 5);
          console.log('Recent orders (without ordering):', this.recentOrders.length, this.recentOrders);
        }

        // Fetch in-progress journeys
        const journeysSnap = await getDocs(collection(db, 'journeys'));
        let inProgress = 0;
        journeysSnap.forEach(doc => {
          const data = doc.data();
          if (data.status === 'IN_PROGRESS') {
            inProgress++;
          }
        });
        this.stats.inProgressJourneys = inProgress;

      } catch (e) {
        console.error('Failed to load statistics', e);
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      try {
        return new Date(dateStr).toLocaleDateString();
      } catch {
        return dateStr;
      }
    },
    viewDetails(item) {
      this.selectedItem = item;
    },
    openImage(url) {
      this.imageModalUrl = url;
    },
    formatAddress(address) {
      if (!address) return 'N/A';
      const parts = [
        address.streetAddress,
        address.city,
        address.state,
        address.country
      ].filter(Boolean);
      return parts.join(', ');
    }
  },
  mounted() {
    this.fetchStatistics();
  }
};
</script>

<style scoped>
.overview-page {
  padding: 20px;
}

h2 {
  color: #e37267;
  margin-bottom: 30px;
  font-size: 28px;
}

.loading {
  padding: 60px;
  text-align: center;
  color: #999;
  font-size: 18px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

.stat-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.users-card .stat-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.orders-card .stat-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.revenue-card .stat-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}

.journeys-card .stat-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: white;
}

.stat-content h3 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #333;
}

.stat-content p {
  margin: 4px 0 0 0;
  color: #666;
  font-size: 14px;
}

.recent-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.recent-section h3 {
  margin: 0 0 20px 0;
  color: #e37267;
  font-size: 20px;
}

.recent-table {
  width: 100%;
  border-collapse: collapse;
}

.recent-table th {
  text-align: left;
  padding: 12px;
  border-bottom: 2px solid #e6d1c7;
  color: #666;
  font-weight: 600;
  font-size: 14px;
}

.recent-table td {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.recent-table tbody tr:hover {
  background: #fafafa;
}

.recent-table code {
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.paid {
  background: #e7f9ed;
  color: #137a2a;
}

.status-badge.unpaid {
  background: #fde8e8;
  color: #b42318;
}

.view-all-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background: #e37267;
  color: white;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.2s;
}

.view-all-btn:hover {
  background: #d66259;
}

.empty {
  padding: 40px;
  text-align: center;
  color: #999;
}

/* Clickable Rows */
.clickable-row {
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.clickable-row:hover {
  background: #f0f9ff !important;
  transform: scale(1.01);
}

/* Modal */
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: grid;
  place-items: center;
  z-index: 9999;
}

.modal-body {
  background: white;
  border-radius: 16px;
  padding: 24px;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e37267;
}

.modal-header h3 {
  margin: 0;
  color: #e37267;
  font-size: 24px;
}

.close {
  background: transparent;
  border: none;
  font-size: 36px;
  color: #999;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s;
}

.close:hover {
  color: #e37267;
}

/* Items Section */
.items-section {
  margin-bottom: 24px;
}

.items-section h4 {
  color: #e37267;
  margin: 0 0 16px 0;
  font-size: 18px;
}

.order-item {
  background: #fafafa;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border-left: 4px solid #e37267;
}

.item-info {
  margin-bottom: 16px;
}

.item-info strong {
  font-size: 18px;
  color: #333;
  display: block;
  margin-bottom: 8px;
}

.item-info p {
  margin: 4px 0;
  color: #666;
  font-size: 14px;
}

/* Personalization */
.personalization {
  background: white;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.personalization h5 {
  margin: 0 0 12px 0;
  color: #e37267;
  font-size: 16px;
}

.personalization p {
  margin: 6px 0;
  font-size: 14px;
  color: #666;
}

/* Images */
.item-images,
.all-images-section {
  margin-top: 16px;
}

.item-images h5,
.all-images-section h4 {
  margin: 0 0 12px 0;
  color: #e37267;
  font-size: 16px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.image-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.image-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(227, 114, 103, 0.3);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Customer Info */
.customer-info {
  background: #f0f9ff;
  padding: 20px;
  border-radius: 12px;
  margin-top: 24px;
}

.customer-info h4 {
  margin: 0 0 16px 0;
  color: #e37267;
  font-size: 18px;
}

.customer-info p {
  margin: 8px 0;
  font-size: 14px;
  color: #666;
}

/* Image Modal */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.9);
  display: grid;
  place-items: center;
  z-index: 10000;
  cursor: pointer;
}

.image-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.image-modal-content img {
  max-width: 100%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

.close-image {
  position: absolute;
  top: -40px;
  right: 0;
  background: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  display: grid;
  place-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  transition: all 0.2s;
}

.close-image:hover {
  background: #e37267;
  color: white;
  transform: scale(1.1);
}
</style>